import { Switch } from "@mui/material";
import { GlobalConfigContainer } from "./style";
import { useContext } from "react";
import { BannerContext } from "../../contexts/BannerDimensionsContext";
import { Checkbox } from "@mui/material";
import { pink } from "@mui/material/colors";
import "./index.css";

const GlobalConfig = () => {
  const {
    imageFormat,
    setImageFormat,
    printStages,
    setPrintStages,
    previewGridActive,
    setPreviewGridActive,
  } = useContext(BannerContext);
  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const handleShowGrid = () => {
    setPreviewGridActive(!previewGridActive);
  };

  const handleChangeImageFormat = async () => {
    imageFormat === "png"
      ? await setImageFormat("jpg")
      : await setImageFormat("png")
  }

  return (
    <GlobalConfigContainer>
      <div className="selectImageBackup">
        <p>Imagens / Backup</p>

        <select
          style={{ width: '100px', marginLeft: '10px', padding: '4px 8px', borderRadius: '4px', border: '1px solid #ccc' }}
          defaultValue={imageFormat}
          onChange={e => setImageFormat(e.target.options[e.target.selectedIndex].text)}
        >
          {['png', 'jpg', 'webp'].map((image, idx) => (
            <option key={idx}>
              {image}
            </option>
          ))}
        </select>
      </div>
      <div className="print-stage">
        <span
          onClick={handleShowGrid}
          style={{ cursor: "pointer" }}
          className="gridButton"
        >
          Grid Previews
        </span>
        <div
          className="printCheckbox"
          style={{ display: "flex", alignItems: "center" }}
        >
          <span style={{ marginRight: "10px" }}>Print dos Steps</span>
          <Checkbox
            {...label}
            checked={printStages}
            onChange={() => setPrintStages(!printStages)}
            sx={{
              color: pink[800],
              "&.Mui-checked": {
                color: pink[600],
              },
            }}
          />
        </div>
      </div>
    </GlobalConfigContainer>
  );
};

export default GlobalConfig;
